<template>
    <div class="text-center mt-20 justify-center">
      <h1 class="text-4xl font-bold">404 - Page Not Found</h1>
      <p class="text-lg mt-4">The page you are looking for does not exist.</p>
      <router-link to="/dashboard" class="mt-6 inline-block text-blue-500 underline">Go Home</router-link>
    </div>
  </template>
  
  <script>
  export default {
    name: 'NotFound',
    mounted() {
    window.scrollTo(0, 0);
    },
  };
  </script>
